<template>
  <div class="max-h-screen">
    <TopBar />
    <div class="fill-and-flex">
      <slot />
    </div>
  </div>
</template>

<script>
import TopBar from "@/components/TopBar";

export default {
  name: "DefaultLayout",
  components: {
    TopBar,
  },
};
</script>
